module.exports = __webpack_public_path__ + "img/hanyue.050b5920.png";